import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home/";
import Error404 from "../views/Error404/";
// import { i18n } from "@/plugins/i18n.js";
import i18n from '@/plugins/i18n';
import store from '@/store';

Vue.use(VueRouter);


const routes = [
  {
    path: '/:lang(es|br|en)?',
    name: "Home",
    component: Home,
    beforeEnter: (to, from, next) => {
      // ...
      let lang;

      if(to.params.lang) {
        lang = to.params.lang;
      }
      else
      {
        lang = "es";
      }

      i18n.locale = lang;
      store.dispatch('setLanguage', lang);

      //no initial video ID
      store.dispatch('setLoadComplete', true);

      next();
    }
  },
  {
    path: '/404.html',
    name: "Error404",
    props: true,
    component: Error404,
    beforeEnter: (to, from, next) => {

      let lang;
      if(to.params.lang) {
        lang = to.params.lang;
      } else {
        lang = "es";
      }

      i18n.locale = lang;
      store.dispatch('setLanguage', lang);
      next();
    }
  },
  {
    path: '/:lang(es|br|en)?/:idVideo',
    name: "Home",
    props: true,
    component: Home,
    beforeEnter: (to, from, next) => {

      if(to.params.idVideo !== undefined)
      {
        store.dispatch('setInitialVideoID', to.params.idVideo);
      }

      let lang;
      if(to.params.lang) {
        lang = to.params.lang;
      } else {
        lang = "es";
      }

      i18n.locale = lang;
      store.dispatch('setLanguage', lang);
      next();
    }
  }
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});



//https://blog.logrocket.com/advanced-localization-techniques-vue-js/
// router.beforeEach((to, from, next) => {

//   if ( store.state.language && store.state.language !== i18n.locale ) {
//     i18n.locale = store.state.language;
//     next();
//   } else if (!store.state.language) {
//     store.dispatch("setLanguage", navigator.languages).then(() => {
//       i18n.locale = store.state.language;
//       next();
//     });
//   } else {
//     next();
//   }
// });

export default router;
